import { env, requireAccessCode } from "./envConfig";
const axios = require("axios");

const baseUrl = `${env.REACT_APP_BACKEND_APP_NAME}/api`;

export const axiosApiInstance = axios.create();

axiosApiInstance.defaults.baseURL = `${env.REACT_APP_BACKEND_APP_NAME}`;
// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
  async (config: any) => {
    config.headers = {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      Accept: "application/json",
      "Content-Type": "application/json; charset=utf-8",
    };
    return config;
  },
  (error: any) => {
    Promise.reject(error);
  }
);

// A guest token can expire mid-session (it's issued silently, with no login step to fall
// back to); transparently mint a fresh one and retry once rather than surfacing a 401.
axiosApiInstance.interceptors.response.use(
  (response: any) => response,
  async (error: any) => {
    const originalRequest = error.config;
    if (!requireAccessCode && error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const res = await axios.post(`${baseUrl}/auth/guest-token`);
        sessionStorage.setItem('token', res.data.access_token);
        sessionStorage.setItem('is_admin', '0');
        return axiosApiInstance(originalRequest);
      } catch {
        sessionStorage.removeItem('token');
      }
    }
    return Promise.reject(error);
  }
);
